// Use environment variable or detect local development
let API_BASE_URL;
if (process.env.NODE_ENV === 'development' && window.location.hostname === 'localhost') {
  API_BASE_URL = 'https://localhost:7080/api'; // Local .NET API
} else {
  API_BASE_URL = process.env.REACT_APP_API_URL || 'https://xero-payment-api-cmb-c0epbxffhccgdsbs.canadacentral-01.azurewebsites.net/api';
}
console.log('🔗 Auth API Base URL:', API_BASE_URL);
console.log('🌍 Auth Environment:', process.env.NODE_ENV);
console.log('🏠 Auth Hostname:', window.location.hostname);
// Updated for Azure
class AuthService {
  static async login(loginData) {
    try {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(loginData),
      });

      const data = await response.json();
      
      if (response.ok) {
        return data;
      } else {
        throw new Error(data.message || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  }

  static async register(registerData) {
    try {
      console.log('📤 Sending registration request to:', `${API_BASE_URL}/auth/register`);
      console.log('📋 Registration payload:', {
        ...registerData,
        password: '[HIDDEN]',
        confirmPassword: '[HIDDEN]'
      });
      
      const response = await fetch(`${API_BASE_URL}/auth/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(registerData),
      });

      console.log('📊 HTTP Response Status:', response.status, response.statusText);
      console.log('📋 Response Headers:', Object.fromEntries(response.headers.entries()));

      let data;
      try {
        data = await response.json();
        console.log('📄 Response Body:', data);
      } catch (jsonError) {
        console.error('❌ Failed to parse JSON response:', jsonError);
        const textResponse = await response.text();
        console.error('📄 Raw response text:', textResponse);
        throw new Error(`Server returned invalid JSON. Status: ${response.status}, Response: ${textResponse}`);
      }
      
      if (response.ok) {
        console.log('✅ Registration successful');
        return data;
      } else {
        console.error('❌ Registration failed. Status:', response.status);
        console.error('❌ Error data:', data);
        throw new Error(data.message || data.error || `Registration failed with status ${response.status}`);
      }
    } catch (error) {
      console.error('💥 Registration error:', error);
      throw error;
    }
  }

  static async getCurrentUser() {
    try {
      const token = this.getToken();
      if (!token) {
        throw new Error('No token found');
      }

      const response = await fetch(`${API_BASE_URL}/auth/me`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      
      if (response.ok) {
        return data;
      } else {
        throw new Error(data.message || 'Failed to get current user');
      }
    } catch (error) {
      console.error('Get current user error:', error);
      throw error;
    }
  }

  static async logout() {
    try {
      const token = this.getToken();
      if (token) {
        await fetch(`${API_BASE_URL}/auth/logout`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
      }
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Always clear local storage
      this.clearToken();
    }
  }

  static async validateToken() {
    try {
      const token = this.getToken();
      if (!token) {
        return false;
      }

      const response = await fetch(`${API_BASE_URL}/auth/validate-token`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      return response.ok && data.valid;
    } catch (error) {
      console.error('Token validation error:', error);
      return false;
    }
  }

  static getToken() {
    return localStorage.getItem('token');
  }

  static setToken(token) {
    localStorage.setItem('token', token);
  }

  static clearToken() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }

  static getUser() {
    const userStr = localStorage.getItem('user');
    try {
      return userStr ? JSON.parse(userStr) : null;
    } catch (error) {
      console.error('Error parsing user data:', error);
      return null;
    }
  }

  static setUser(user) {
    localStorage.setItem('user', JSON.stringify(user));
  }

  static isAuthenticated() {
    const token = this.getToken();
    const user = this.getUser();
    return token && user;
  }

  // Helper method to add auth headers to API requests
  static getAuthHeaders() {
    const token = this.getToken();
    return {
      'Authorization': token ? `Bearer ${token}` : '',
      'Content-Type': 'application/json',
    };
  }

  // Method to handle API calls with automatic token refresh
  static async apiCall(url, options = {}) {
    const token = this.getToken();
    
    const headers = {
      'Content-Type': 'application/json',
      ...options.headers,
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(`${API_BASE_URL}${url}`, {
      ...options,
      headers,
    });

    // If unauthorized, try to refresh token or redirect to login
    if (response.status === 401) {
      this.clearToken();
      window.location.href = '/login';
      throw new Error('Authentication required');
    }

    return response;
  }
}

export default AuthService;






